import {
	CalcType,
	FormField,
	Formula,
	Operation,
	Parameter,
	Rule,
	RuleTest,
	Variable,
} from 'api';
import { CalcItemStatusEnum } from '../../utils/AppEnums';
import * as actionTypes from './actionTypes';
import * as helpers from './helpers';

// TODO: implement interfaces from generated api models when done
export interface ICalculatorWizard {
	calcType: CalcType;
	rules: Array<IRule>;
	rule: IRule | null;
	formulae: Array<Formula>;
	formula: Formula | null;
	parameters: Array<Parameter>;
	operations: Array<Operation>;
	definitions: Array<Formula>;
	variables: Array<Variable>;
	constants: Array<any>;
	formFields: Array<FormField>;
	loading: {
		rules: boolean;
		rule: boolean;
		formulae: boolean;
		formula: boolean;
		params: boolean;
		operations: boolean;
		validation: boolean;
		constants: boolean;
		variables: boolean;
		formFields: boolean;
	};
	fetched: {
		rules: boolean;
		params: boolean;
		operations: boolean;
		constants: boolean;
		variables: boolean;
		formFields: boolean;
	};
	constantId: number | null;
	saved: boolean;
	validation: RuleTest;
	error: string;
}

export interface IRule extends Rule {
	key: string;
	status: CalcItemStatusEnum;
}

export interface IFormula extends Formula {
	status: CalcItemStatusEnum;
}

export interface IRelationMap {
	[key: string]: Array<number>;
}

export interface IRelations {
	parent: Array<number>;
	children: Array<number>;
	//siblings: Array<number>;
	set: boolean;
}

export const INITIAL_STATE: ICalculatorWizard = {
	calcType: CalcType.Standard,
	rules: [],
	rule: null,
	formulae: [],
	formula: null,
	parameters: [],
	operations: [],
	definitions: [],
	variables: [],
	constants: [],
	formFields: [],
	loading: {
		rules: false,
		rule: false,
		formulae: false,
		formula: false,
		params: false,
		operations: false,
		validation: false,
		constants: false,
		variables: false,
		formFields: false
	},
	fetched: {
		rules: false,
		params: false,
		operations: false,
		constants: false,
		variables: false,
		formFields: false
	},
	constantId: null,
	saved: true,
	validation: {},
	error: '',
};

const Calculator = (
	state = INITIAL_STATE,
	action: { type: string; payload: any }
) => {
	switch (action.type) {
		case actionTypes.SET_CALC_TYPE:
			state = {
				...state,
				fetched: {
					...state.fetched,
					rules: false,
					params: false,
					variables: false,
				},
				calcType: action.payload,
			};
			break;
		case actionTypes.GET_RULES:
			state = {
				...state,
				loading: {
					...state.loading,
					rules: true,
				},
			};
			break;
		case actionTypes.SET_RULES:
			state = {
				...state,
				loading: {
					...state.loading,
					rules: false,
				},
				fetched: {
					...state.fetched,
					rules: true,
				},
				rules: helpers.mapRulesToInternal(action.payload),
			};
			break;
		case actionTypes.GET_RULE:
			state = {
				...state,
				loading: {
					...state.loading,
					rule: true,
				},
			};
			break;
		case actionTypes.SET_RULE:
			state = {
				...state,
				loading: {
					...state.loading,
					rule: false,
				},
				rule: { ...helpers.mapRuleToInternal(action.payload) },
			};
			break;
		case actionTypes.SAVE_RULE:
			state = {
				...state,
				rules: [...state.rules, action.payload],
			};
			break;
		case actionTypes.TEST_RULE:
			state = {
				...state,
				loading: {
					...state.loading,
					validation: true,
				},
				validation: {
					...state.validation,
					valid: undefined,
				},
			};
			break;
		case actionTypes.TESTED_RULE:
			state = {
				...state,
				validation: action.payload,
				loading: {
					...state.loading,
					validation: false,
				},
			};
			break;
		case actionTypes.TEST_ERROR:
			state = {
				...state,
				loading: {
					...state.loading,
					validation: false,
				},
			};
			break;

		case actionTypes.GET_FORMULAE:
			state = {
				...state,
				loading: {
					...state.loading,
					formulae: true,
				},
			};
			break;
		case actionTypes.SET_FORMULAE:
			state = {
				...state,
				formulae: action.payload,
				loading: {
					...state.loading,
					formulae: false,
				},
			};
			break;

		case actionTypes.MOVE_FORMULA:
			state = {
				...state,
				loading: {
					...state.loading,
					formulae: true,
				},
			};
			break;

		case actionTypes.MOVE_RULE:
			state = {
				...state,
				loading: {
					...state.loading,
					rules: true,
				},
			};
			break;

		case actionTypes.GET_FORMULAE_DEFS:
			state = {
				...state,
				loading: {
					...state.loading,
					formulae: true,
				},
			};
			break;
		case actionTypes.SET_FORMULAE_DEFS:
			state = {
				...state,
				definitions: action.payload,
				loading: {
					...state.loading,
					formulae: false,
				},
			};
			break;
		case actionTypes.GET_FORMULA:
			state = {
				...state,
				loading: {
					...state.loading,
					formula: true,
				},
			};
			break;
		case actionTypes.SET_FORMULA:
			state = {
				...state,
				formula: action.payload,
				loading: {
					...state.loading,
					formula: false,
				},
			};
			break;
		case actionTypes.SAVE_FORMULA:
			state = {
				...state,
				formula: action.payload.formula,
			};
			break;

		case actionTypes.DELETED_RULE:
			state = {
				...state,
				//rules: action.payload
			};
			break;

		case actionTypes.SET_PARAMETERS:
			state = {
				...state,
				parameters: action.payload,
				loading: {
					...state.loading,
					params: false,
				},
				fetched: {
					...state.fetched,
					params: true,
				},
			};
			break;

		case actionTypes.GET_VARIABLES:
			state = {
				...state,
				loading: {
					...state.loading,
					variables: true,
				},
			};
			break;
		case actionTypes.SET_VARIABLES:
			state = {
				...state,
				variables: action.payload,
				loading: {
					...state.loading,
					variables: false,
				},
				fetched: {
					...state.fetched,
					variables: true,
				},
			};
			break;

		case actionTypes.GET_CONSTANTS:
			state = {
				...state,
				loading: {
					...state.loading,
					constants: true,
				},
			};
			break;

		case actionTypes.SET_CONSTANTS:
			state = {
				...state,
				constants: action.payload,
				loading: {
					...state.loading,
					constants: false,
				},
				fetched: {
					...state.fetched,
					constants: true,
				},
			};
			break;

		case actionTypes.SET_CONST_VALUE:
			state = {
				...state,
				constants: [...state.constants, action.payload],
				loading: {
					...state.loading,
					constants: false,
				},
			};
			break;

		case actionTypes.SET_OPERATIONS:
			state = {
				...state,
				operations: action.payload,
				loading: {
					...state.loading,
					operations: false,
				},
				fetched: {
					...state.fetched,
					operations: true,
				},
			};
			break;

		case actionTypes.RULE_ERROR:
			state = {
				...state,
				error: action.payload,
			};
			break;

		case actionTypes.SET_CONSTANT_ID:
			state = {
				...state,
				constantId: action.payload,
			};
			break;

		case actionTypes.REMOVE_CONSTANT_ID:
			state = {
				...state,
				constantId: null,
			};
			break;

		case actionTypes.SET_FORM_FIELDS:
			state = {
				...state,
				formFields: action.payload
			}
			break;
		default:
			state = { ...state };
			break;
	}
	//console.log("state", state);
	return state;
};

export default Calculator;
